import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useEffect } from 'react';
import Text from './Text.js';

function PhoneNumber(_a) {
    var value = _a.value, onChange = _a.onChange, inputRef = _a.inputRef, isFocused = _a.isFocused, props = __rest(_a, ["value", "onChange", "inputRef", "isFocused"]);
    useEffect(function () {
        var _a;
        if (isFocused && inputRef.current) {
            (_a = inputRef.current).setSelectionRange.apply(_a, getSelectionRange(value.length));
        }
    }, [inputRef, isFocused, value.length]);
    return (React.createElement(Text, __assign({ inputRef: inputRef, isFocused: isFocused, value: formattedDate(value), onChange: function (e) {
            var normalizedDate = normalizeDate(e.target.value);
            e.target.value = normalizedDate;
            onChange(e);
        } }, props)));
}
function getSelectionRange(length) {
    if (length <= 3) {
        return [length, length];
    }
    if (length <= 7) {
        return [length + 1, length + 1];
    }
    return [length + 2, length + 2];
}
function formattedDate(value) {
    if (value.length <= 3) {
        return value;
    }
    if (value.length <= 7) {
        return value.slice(0, 3) + "-" + value.slice(3);
    }
    return value.slice(0, 3) + "-" + value.slice(3, 7) + "-" + value.slice(7);
}
function normalizeDate(value) {
    var normalizedDate = value.replace(/[^0-9]/g, '').slice(0, 11);
    if (!normalizedDate) {
        return normalizedDate;
    }
    if (normalizedDate.length === 1) {
        return '0';
    }
    if (normalizedDate.length === 2) {
        return '01';
    }
    return "010" + normalizedDate.slice(3);
}

export { PhoneNumber as default };
